import { getOGImageURL, getOGSearchUrl, getOGSiteName, getOGTitleName } from '@digital-retail/store-manager';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import PropTypes from 'prop-types';
import apiConfig from '../../config/api/apiConfig';

export const SLPSeo = ({ SiteProps }) => {
  const { regionCode, keywords, searchTerm, store, metadata, isShopPage, shopPageId } = SiteProps;
  const title = metadata?.title || getOGTitleName({ store, regionCode });
  const description = metadata?.description || '';
  const canonical =
    metadata?.canonical || apiConfig.getCanonicalUrl({ regionCode, searchTerm, store, isShopPage, shopPageId });
  const siteName = getOGSiteName({ regionCode, store });
  const url = getOGSearchUrl({ regionCode, store });

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <NextSeo
        canonical={canonical}
        noindex={!metadata?.isSEOIndexable}
        description={description}
        openGraph={{
          description,
          url,
          site_name: siteName,
          title,
          images: [
            {
              url: getOGImageURL({ regionCode, store }),
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'Keywords',
            content: keywords || '',
          },
        ]}
      />
    </>
  );
};

SLPSeo.propTypes = {
  SiteProps: PropTypes.object.isRequired,
};
